import React, { useEffect, useState } from "react";
import RecordTable from "../components/Records_Table";
import { buildApiUrl } from "../config/api";

export default function Records({ initialRecords = [] }) {
  const [records, setRecords] = useState(() => {
    if (initialRecords.length > 0) {
      return initialRecords;
    }

    const cached = sessionStorage.getItem("league_records");
    return cached ? JSON.parse(cached) : [];
  });
  const [loading, setLoading] = useState(records.length === 0);

  useEffect(() => {
    if (initialRecords.length === 0) {
      return;
    }

    sessionStorage.setItem("league_records", JSON.stringify(initialRecords));
    setRecords(initialRecords);
    setLoading(false);
  }, [initialRecords]);

  useEffect(() => {
    if (records.length > 0) return; // ✅ already cached

    fetch(buildApiUrl("/records"))
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched records:", data.data);
        sessionStorage.setItem("league_records", JSON.stringify(data.data));
        setRecords(data.data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching records:", err);
        setLoading(false);
      });
  }, [records]);

  return (
    <div className="space-y-6 p-2 sm:p-4">
      {loading ? (
        <p className="text-center text-[var(--muted-text)]">Loading record book...</p>
      ) : records.length === 0 ? (
        <p className="text-center text-[var(--muted-text)]">No records available.</p>
      ) : (
        <RecordTable records={records} />
      )}
    </div>
  );
}
